import { useAuthStore } from "~/stores/auth";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const doAuth = typeof to.meta.auth == 'boolean' ? to.meta.auth : true

  if(to.path.includes('/public/')) {
    return;
  }

  const security = useSecurity()
  const auth = useAuthStore()
  
  let result = await security.initialize()
  
  if (auth.status == "authenticated" && !result.isStandalone && (to.path == '/login' || to.path == '/status-cerere' || to.path == '/standalone/redirect')) {
    return navigateTo('/');
  }

  if (result.authenticated && result.isStandalone) {
    const allowed = ['/cereri', '/login']
    const isDynamicCerere = to.path.startsWith('/cereri')

    if (!allowed.includes(to.path) && !isDynamicCerere) {
      return navigateTo('/cereri')
    } else {
      return
    }
  }
  
  if (auth.status == "authenticated") {
    return
  }
  
  if (to.path == '/status-cerere' || to.path == '/standalone/redirect') {
    return
  }
  
  if ((to.path == '/login' || !doAuth) && auth.status == "unauthenticated") {
    return;
  }
  
  if (to.path == '/openid') {
    if (to.query.error === 'access_denied') {
      return navigateTo("/login");
    }
    if (await security.requestOpenIDToken()) {
      return navigateTo("/")
    }
    return
  }


  if (result.authenticated) {
      return navigateTo('/')
  }

  let redirectUrl = result.redirectUrl ?? "/login"
  return navigateTo(redirectUrl, { external: !redirectUrl.startsWith("/") });
})
